import { openBlock as t, createElementBlock as o, createElementVNode as l } from "vue";
const e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ l("path", {
  fill: "#496E2D",
  d: "M34.143 34.143c7.5-7.501 7.797-19.477.892-27.333L20 20 6.81 35.034c7.857 6.906 19.832 6.61 27.333-.891Z"
}, null, -1), h = /* @__PURE__ */ l("path", {
  fill: "#0052B4",
  d: "M5.857 5.857c7.501-7.5 19.476-7.797 27.333-.891L20 20 4.966 33.19c-6.906-7.856-6.61-19.832.891-27.333Z"
}, null, -1), c = /* @__PURE__ */ l("path", {
  fill: "#FFDA44",
  d: "M33.19 4.966 4.966 33.19a20.192 20.192 0 0 0 1.844 1.844L35.034 6.81a20.221 20.221 0 0 0-.891-.953c-.31-.31-.629-.606-.953-.891Z"
}, null, -1), s = /* @__PURE__ */ l("path", {
  fill: "#F0F0F0",
  d: "m8.427 6.956.432 1.329h1.396l-1.13.82.432 1.33-1.13-.822-1.13.821.431-1.328-1.13-.821h1.397l.432-1.329Zm7.136 0 .431 1.329h1.397l-1.13.82.432 1.33-1.13-.822-1.13.821.431-1.328-1.13-.821h1.397l.432-1.329Zm-7.136 6.957.432 1.328h1.396l-1.13.822.432 1.328-1.13-.821-1.13.821.431-1.328-1.13-.822h1.397l.432-1.328Zm7.136 0 .431 1.328h1.397l-1.13.822.432 1.328-1.13-.821-1.13.821.431-1.328-1.13-.822h1.397l.432-1.328Zm-3.568-3.479.432 1.329h1.396l-1.13.821.432 1.329-1.13-.821-1.13.82.431-1.328-1.13-.821h1.397l.432-1.329Z"
}, null, -1), d = [
  n,
  h,
  c,
  s
];
function i(_, a) {
  return t(), o("svg", e, [...d]);
}
const m = { render: i };
export {
  m as default,
  i as render
};
